import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';

import client from 'gql/client';
import {
  clearTokens,
} from 'utils/cookies';
import { logoutCurrentUser } from 'state/actions';
import { postRequest } from 'utils/api';

export const useLogout = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  // eslint-disable-next-line consistent-return
  return useCallback(async () => {
    try {
      const endpoint = '/auth/logout';

      const response = await postRequest({ endpoint });

      clearTokens();
      client.clearStore();
      queryClient.clear();
      dispatch(logoutCurrentUser());

      return response;
    } catch (error) {
      clearTokens();

      client.clearStore();
      queryClient.clear();

      window.location.href = window.location.origin;
    }
  }, [dispatch, queryClient]);
};
